import {
  EvaluationResultSpecific,
  Metric,
} from '@agilelab/plugin-wb-governance-common';
import {
  WbCard,
  WbCardContent,
  WbTabPanel,
  WbViewTabs,
  WbTabsContext,
  WbViewTabItem,
} from '@agilelab/plugin-wb-platform';
import { Box } from '@material-ui/core';
import { FC, useMemo, useState } from 'react';
import { GovernanceTestOverviewInfo } from '../GovernanceTestOverviewInfo';
import { GovernanceTestOverviewMetricDetails } from './MetricErrorsDetails';
import { GovernanceTestOverviewMetricInfo } from './OverviewMetricInfoBox';

interface Props {
  result?: EvaluationResultSpecific;
  metric: Metric;
  infoContent?: JSX.Element;
  test?: {
    errors?: string[];
    content: string;
    name: string;
  };
}

enum Tab {
  Result = 'result',
  Entity = 'metric',
}

export const GovernanceTestOverviewMetricTabs: FC<Props> = props => {
  const [selectedTab, setSelectedTab] = useState<Tab>(Tab.Result);

  const test = useMemo(() => {
    if (props.test) return props.test;

    if (props.result)
      return {
        errors: props.result.result?.errors || [],
        content: props.result.resource_content,
        name:
          props.result.resource_display_name ||
          props.result.resource.external_id,
      };

    return undefined;
  }, [props.result, props.test]);
  return (
    <WbTabsContext
      value={selectedTab}
      onValueChange={value => setSelectedTab(value as Tab)}
    >
      <WbCard
        cardStyle={{ height: '100%' }}
        title="Overview"
        actions={
          <WbViewTabs aria-label="Overview sections">
            <WbViewTabItem value={Tab.Result} title="Result" />
            <WbViewTabItem value={Tab.Entity} title="Metric" />
          </WbViewTabs>
        }
      >
        <WbCardContent>
          <WbTabPanel value={Tab.Result}>
            <Box
              style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}
            >
              {props.infoContent ? (
                <WbCard title="Info">
                  <WbCardContent>{props.infoContent}</WbCardContent>
                </WbCard>
              ) : (
                props.result && (
                  <GovernanceTestOverviewInfo result={props.result} />
                )
              )}
              {test && (
                <GovernanceTestOverviewMetricDetails {...props} test={test} />
              )}
            </Box>
          </WbTabPanel>
          <WbTabPanel value={Tab.Entity}>
            <GovernanceTestOverviewMetricInfo {...props} />
          </WbTabPanel>
        </WbCardContent>
      </WbCard>
    </WbTabsContext>
  );
};
